import { Link } from 'react-router-dom';
import { useState } from 'react';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setSubmitMessage('Veuillez entrer votre email');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d5nanev72m0gvhnvdvh0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setSubmitMessage('Merci pour votre inscription !');
        setEmail('');
      } else {
        setSubmitMessage('Une erreur est survenue. Veuillez réessayer.');
      }
    } catch (error) {
      setSubmitMessage('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitMessage(''), 3000);
    }
  };

  return (
    <footer className="bg-[#0A0A0A] rounded-t-[40px] mt-20 mx-5 relative overflow-hidden">
      {/* Background Text */}
      <div className="absolute bottom-0 left-0 right-0 pointer-events-none overflow-hidden">
        <p className="text-[#1A1A1A] opacity-30 text-[120px] font-black whitespace-nowrap">
          GRANDE IMPRIMERIE
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Branding Column */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/abfd1896-5d84-4bae-9ef9-cd88b8f43695.png" 
                alt="Grande Imprimerie Logo" 
                className="h-10 w-auto object-contain"
              />
              <h3 className="text-white text-2xl font-bold">GRANDE IMPRIMERIE</h3>
            </div>
            <p className="text-gray-400 text-base leading-relaxed">
              Votre partenaire impression<br />
              et visibilité digitale
            </p>
          </div>

          {/* Navigation Column */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-6">Navigation</h4>
            <ul className="space-y-4">
              <li>
                <Link
                  to="/"
                  className="text-gray-400 text-sm hover:text-[#E63946] transition-colors duration-300 cursor-pointer"
                >
                  Accueil
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-400 text-sm hover:text-[#E63946] transition-colors duration-300 cursor-pointer"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/realisations"
                  className="text-gray-400 text-sm hover:text-[#E63946] transition-colors duration-300 cursor-pointer"
                >
                  Réalisations
                </Link>
              </li>
              <li>
                <Link
                  to="/offres-entreprises"
                  className="text-gray-400 text-sm hover:text-[#E63946] transition-colors duration-300 cursor-pointer"
                >
                  Offres Entreprises
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-400 text-sm hover:text-[#E63946] transition-colors duration-300 cursor-pointer"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Media Column */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-6">Suivez-nous</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 text-gray-400 hover:text-[#E63946] transition-colors duration-300 cursor-pointer"
                >
                  <div className="w-9 h-9 bg-[#1A1A1A] rounded-full flex items-center justify-center hover:bg-[#E63946] transition-colors duration-300">
                    <i className="ri-instagram-line text-sm"></i>
                  </div>
                  <span className="text-sm">Instagram</span>
                </a>
              </li>
              <li>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 text-gray-400 hover:text-[#E63946] transition-colors duration-300 cursor-pointer"
                >
                  <div className="w-9 h-9 bg-[#1A1A1A] rounded-full flex items-center justify-center hover:bg-[#E63946] transition-colors duration-300">
                    <i className="ri-facebook-fill text-sm"></i>
                  </div>
                  <span className="text-sm">Facebook</span>
                </a>
              </li>
              <li>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 text-gray-400 hover:text-[#E63946] transition-colors duration-300 cursor-pointer"
                >
                  <div className="w-9 h-9 bg-[#1A1A1A] rounded-full flex items-center justify-center hover:bg-[#E63946] transition-colors duration-300">
                    <i className="ri-linkedin-fill text-sm"></i>
                  </div>
                  <span className="text-sm">LinkedIn</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter Column */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-6">Restez Informés</h4>
            <p className="text-gray-400 text-sm mb-4">
              Recevez nos offres<br />
              et actualités
            </p>
            <form onSubmit={handleNewsletterSubmit} data-readdy-form id="newsletter-form" className="relative">
              <div className="flex items-center bg-[#1A1A1A] rounded-full border border-gray-700 overflow-hidden">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Votre email"
                  className="flex-1 bg-transparent text-white text-sm px-5 py-3 outline-none placeholder-gray-500"
                  disabled={isSubmitting}
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-11 h-11 bg-white rounded-full flex items-center justify-center m-1 hover:scale-105 transition-transform duration-300 cursor-pointer"
                >
                  <i className="ri-arrow-right-line text-[#E63946] text-lg"></i>
                </button>
              </div>
              {submitMessage && (
                <p className={`text-xs mt-2 ${submitMessage.includes('Merci') ? 'text-green-400' : 'text-red-400'}`}>
                  {submitMessage}
                </p>
              )}
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-gray-500 text-sm">
            © 2025 Grande Imprimerie. Tous droits réservés.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-500 text-sm hover:text-[#E63946] transition-colors duration-300 cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;